import * as React from 'react';
import { graphql } from 'gatsby';
import { createGatsbyPageComponent } from '@shapeable/ui';
import { transformTopic } from '../../utils/transforms';
import { TopicExplorerLayout } from '../../components/entities/topic-explorer-layout';

export default createGatsbyPageComponent('Topic', { layout: TopicExplorerLayout, transform: transformTopic });

export const topicQuery = graphql`
  query TopicQuery($id: ID!) {
    platform {
      topic(id: $id) {
        id slug name path __typename
        openGraph { image { thumbnails { full { url url2x } card { url url2x } } } }
        created
        updated
        published
        doiId
        outlineNumber
        trend { id path slug name __typename }
        description { text }
        intro { text }
        anticipatoryImpact { text }
        indicatorValues {
          id value numericValue year
          indicator { id name title slug dataSetId color { id value } }
        }
        editions { id name slug numericValue }
        anticipatoryImpactImage { 
          image {
            id
            url
          }
        }
        embeds {
          citations {
            id slug url name authors { id name slug } 
            authorShowsEtAl edition publication accessDate 
            startPage volume footnoteNumber year
          }
          imageAssets {
            id
            slug
            image {
              id url url2x width height type 
            }
          }
        }
        videos {
          id name url __typename _schema { label pluralLabel }
          openGraph { description { plain } url title image { thumbnails { card { url url2x } small { url url2x } } } }
        }
        surveyObservations { text }
        color { id name slug value darkValue veryDarkValue }
        banner {
          id
          name
          description { text }
          license {
            id
            name
            url
            description { text }
          }
          image {
            id
            url
            width
            height
            thumbnails { mainBanner { url url2x } }
          }
        }
        trend {
          id name slug __typename
          outlineNumber
          openGraph { image { thumbnails { card { url } } } }
          color { id name slug value }
        }
        chartImage { 
          id
          slug
          image { 
            id url url2x
          }
        }
        feedEntries {
          __typename _schema { label pluralLabel }
          id name slug __typename url published websiteName
          openGraph { image { url url2x thumbnails { card { url url2x } card { url url2x } } } }
          topic { id color { value } }
        }
        citations {
          __typename _schema { label pluralLabel }
          typeLabel
          slug url name authors { id name slug }
          authorShowsEtAl edition publication accessDate
          startPage volume footnoteNumber year
        }
        subTopics {
          id name outlineNumber slug __typename 
          color { id name value }
          topic { id slug path }
          intro { text }
          description { text }
          anticipationScores { text }
          anticipationScoresImage {
            id
            image {
              id url url2x width height
            }
          }
          horizons {
            __typename id name slug
            intro { text }
            description { text }
            color { __typename id name slug value }
            type { __typename id name slug years title subtitle }
            embeds {
              citations {
                slug url name authors { id name } authorShowsEtAl edition publication accessDate startPage volume footnoteNumber year
              }
            }
          }
          indicatorValues {
            id value numericValue year
            indicator { id name title slug dataSetId color { id value } }
          }
          embeds {
            citations {
              slug url name authors { name } authorShowsEtAl edition publication accessDate startPage volume footnoteNumber year
            }
            imageAssets {
              id
              slug
              image {
                id url url2x width height type 
              }
            }
          }
        }
        events { 
          id name slug path __typename _schema { label pluralLabel }
          types { id name slug }
          openGraph { image { url url2x thumbnails { card { url url2x } } } }
        }
        committeeMembers {
          __typename id name slug position path
          badge
          color { value }
          topicExpertise {
            id name slug editions { id name slug }
            topic { id name slug path outlineNumber color { value } }
          }
          openGraph { image { id url url2x thumbnails { medium { url url2x } } } }
          organisation { id name slug }
          linkedin
          hasConnectedTopics
        }
        committeeChairs {
          __typename id name slug position path
          badge
          openGraph { id title image { id url url2x thumbnails { card { id url url2x } } } }
          organisation { id name slug }
          topicExpertise {
            id name slug editions { id name slug }
            topic { id name slug path outlineNumber color { value } }
          }
        }
        connectedPages {
          id name typeLabel slug path __typename type { name slug }
          trend { id name slug path outlineNumber color { value } }
          site { id name slug }
          openGraph { image { url url2x thumbnails { card { url url2x } } } }
        }
      }
    }
  }
`;
